import { Col, Row } from 'antd'
import { ModuleProps } from 'src/types/type'

import CheckboxItem from './CheckboxItem'

function ModuleDetailsPage({
  selectedModule,
  checkedModulesAndClusters,
  handleCheckboxChange,
  slugLinks = []
}: ModuleProps) {
  return (
    <div className="correlation-card">
      <h4 className="correlation-card__heading fw-bold leading-1">
        {selectedModule.module}
      </h4>
      <div className="correlation-card__content">
        <Row className="sub-card">
          {selectedModule.games.map(({ name, category }) => (
            <Col md={24} lg={12} className="sub-card-item" key={name}>
              {category.length > 0 ? (
                <>
                  <div className="sub-card-item__title fw-bold leading-1">
                    {name}
                  </div>
                  <ul>
                    {category.flatMap(({ name: categoryName }) =>
                      // Remove duplicates and enforce uniformity (lowercase, trimmed, and unique items)
                      Array.from(
                        new Set(
                          categoryName
                            .split('\n')
                            .map((item) => item.trim().toLowerCase()) // Normalize: trim and convert to lowercase
                            .filter((item) => item.length > 0) // Remove empty strings
                        )
                      ).map((categoryItem) => (
                        <CheckboxItem
                          selectedModule={selectedModule}
                          key={categoryItem}
                          name={name}
                          label={categoryItem}
                          checkedModulesAndClusters={checkedModulesAndClusters}
                          handleCheckboxChange={handleCheckboxChange}
                          slugLinks={slugLinks}
                        />
                      ))
                    )}
                  </ul>
                </>
              ) : (
                <ul>
                  {name.split('\n').map((gameName) => (
                    <CheckboxItem
                      selectedModule={selectedModule}
                      key={gameName}
                      label={gameName}
                      name={name}
                      checkedModulesAndClusters={checkedModulesAndClusters}
                      handleCheckboxChange={handleCheckboxChange}
                      slugLinks={slugLinks}
                    />
                  ))}
                </ul>
              )}
            </Col>
          ))}
        </Row>
      </div>
    </div>
  )
}

export default ModuleDetailsPage
